<template>
  <div class="media-kit">
    <CRow>
      <CCol col="12">
        <h5 class="m-0" v-translate>Access tools</h5>
        <p v-translate translate-context="event_wizard.overview">Share them with participants for access to the event
          gallery</p>
      </CCol>
      <CCol xl="6">
        <CCard>
          <CCardHeader>
            <h5 class="m-0" v-translate>Direct link</h5>
          </CCardHeader>
          <CCardBody>
            <div>
              <CRow class="align-items-center justify-content-between">
                <CCol>
                  <label class="small d-block" v-translate translate-context="event_wizard.overview">Direct event
                    link</label>
                  <div class="d-flex align-items-center">
                    <CInput :value="mediaKit.direct_link" readonly class="w-100 m-0"/>
                    <div>
                      <CButton color="dark" class="btn-circle ml-3" variant="outline" size="sm"
                               @click="copyURL(mediaKit.direct_link, $gettext('Direct event link'))">
                        <CIcon name="cipCopy" class="text-primary"/>
                      </CButton>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mt-1" v-if="mediaKit.short_direct_link">
                    <CInput :value="mediaKit.short_direct_link" readonly class="w-100 m-0"/>
                    <div>
                      <CButton color="dark" class="btn-circle ml-3" variant="outline" size="sm"
                               @click="copyURL(mediaKit.short_direct_link, $gettext('Direct event link'))">
                        <CIcon name="cipCopy" class="text-primary"/>
                      </CButton>
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow class="py-4 align-items-center justify-content-between">
                <CCol>
                  <label class="small d-block" v-translate translate-context="event_wizard.overview">QR code</label>
                  <div class="d-flex align-items-center">
                    <CInput :value="mediaKit.qr_code" readonly class="w-100 m-0"/>
                    <div>
                      <CButton color="dark" class="btn-circle ml-3" variant="outline" size="sm"
                               @click="copyURL(mediaKit.qr_code, $gettext('Qr Code'))">
                        <CIcon name="cipCopy" class="text-primary"/>
                      </CButton>
                    </div>
                  </div>
                  <div class="d-flex align-items-center mt-1" v-if="mediaKit.short_qr_code">
                    <CInput :value="mediaKit.short_qr_code" readonly class="w-100 m-0"/>
                    <div>
                      <CButton color="dark" class="btn-circle ml-3" variant="outline" size="sm"
                               @click="copyURL(mediaKit.short_qr_code, $gettext('Qr Code'))">
                        <CIcon name="cipCopy" class="text-primary"/>
                      </CButton>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </div>

            <label class="small" v-translate translate-context="event_wizard.overview">Message</label>
            <div class="d-flex">
              <div class="media-kit__message w-100 mr-3">
                <CTextarea :value="selectedSocialText" class="w-100"/>
                <CButton size="sm" color="dark" variant="outline" class="btn-copy btn-circle"
                         @click="copyURL(selectedSocialText, $gettext('Text'))">
                  <CIcon class="text-primary" name="cipCopy"/>
                </CButton>
              </div>

              <PDropDown show-item-selector @change="onChangeLang" :items="langOptions"/>
            </div>

          </CCardBody>
        </CCard>
      </CCol>
      <CCol xl="6">
        <CCard>
          <CCardHeader>
            <h5 class="m-0" v-translate>QR Code</h5>
          </CCardHeader>
          <CCardBody>
            <QRCodeGenerator ref="qrCodeGenerator" :value="mediaKit.qr_code"
                             :file-name="`QRCode-${picaServiceId}`"/>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import QRCodeGenerator from "@/domain/core/components/qrcode/QRCodeGenerator.vue";
import QrcodeVue from "qrcode.vue";
import PDropDown from "@/domain/core/components/PDropDown.vue";
import {mapGetters} from "vuex";

export default {
  name: 'MediaKit',
  components: {PDropDown, QrcodeVue, QRCodeGenerator},

  props: {
    mediaKit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lang: 'en'
    }
  },
  computed: {
    ...mapGetters('event', [
      'picaServiceId'
    ]),
    langOptions() {
      return [
        {label: 'EN', value: 'en'},
        {label: 'IT', value: 'it'},
        {label: 'FR', value: 'fr'},
        {label: 'DE', value: 'de'},
      ]
    },
    selectedSocialText() {
      return this.mediaKit.social_text[this.lang]
    }
  },
  methods: {
    download() {
      this.$refs.qrCodeGenerator.download()
    },
    copyURL(url, description) {
      navigator.clipboard.writeText(url);
      this.notifyMessage({text: this.$gettext(description + ' copied!'), messageType: 'success'})
    },
    onChangeLang(lang) {
      this.lang = lang
    }
  }
}
</script>
